import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { storyLines } from "@/mocks/siteData";

export default function StoriesSection() {
  return (
    <section id="stories" className="sun-glaze bg-primary-950 py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-30"></div>
      <div className="relative w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-300">
              Stories From the Soil
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-background-50 font-semibold">
            Every Farmer Has a Story
          </h2>
          <p className="mt-6 text-base md:text-lg text-background-200 leading-relaxed">
            We believe the most powerful stories aren't always found in cities. Rythugaru tells
            these stories and brings them closer to you.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <Reveal className="lg:col-span-5">
            <div className="rounded-lg overflow-hidden w-full h-72 md:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=Atmospheric%20portrait%20of%20an%20Indian%20farmer%20walking%20through%20a%20misty%20green%20paddy%20field%20at%20dawn%2C%20carrying%20a%20traditional%20tool%2C%20soft%20natural%20light%2C%20deep%20shadows%2C%20emotional%20storytelling%20mood%2C%20painterly%20stylized%20earthy%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1000&height=1200&seq=rythugaru-story-field&orientation=portrait"
                width={1000}
                height={1200}
                alt="Indian farmer walking through a misty green field at dawn"
                title="Farmer stories from rural India"
                className="w-full h-full object-cover object-top"
                decoding="async"
              />
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={120}>
            <p className="font-heading text-2xl md:text-3xl text-background-50 leading-snug">
              These stories are found...
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 mt-7">
              {storyLines.map((line) => (
                <div key={line} className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full bg-accent-400 mt-2.5 shrink-0"></span>
                  <span className="text-base text-background-200 leading-relaxed">{line}</span>
                </div>
              ))}
            </div>
            <Link
              to="/stories"
              className="mt-9 inline-flex items-center gap-2 bg-background-50 text-primary-900 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore Farmer Stories
              <i className="ri-arrow-right-line"></i>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}